import { render, staticRenderFns } from "./digitalHuman_imageCustomization.vue?vue&type=template&id=abdade0c&scoped=true"
import script from "./digitalHuman_imageCustomization.vue?vue&type=script&setup=true&lang=js"
export * from "./digitalHuman_imageCustomization.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abdade0c",
  null
  
)

export default component.exports